import isEmail from 'validator/es/lib/isEmail';

export default class EmailValidator {
    constructor() {
    }

    validate(value, country, isCountryWithSpecialCharacters) {
        const local = value.split('@');

        if (isCountryWithSpecialCharacters) {
            return (local.length === 2 && local[1].indexOf('.') !== -1);
        } else {
            return isEmail(value);
        }
    }
}
